@if (!asDropdownTemplate()) {
  <rt-dropdown [width]="DropdownWidth.Large" class="new-quick-evaluation">
    <ng-container *ngTemplateOutlet="formTpl" />
  </rt-dropdown>
} @else {
  <ng-container *ngTemplateOutlet="formTpl" />
}

<ng-template #formTpl>
  <div [formGroup]="quickEvaluationForm" (click)="$event.preventDefault()">
    <rt-dropdown-header margin-bottom>
      @if (hasBackAction()) {
        <rt-icon-button
          prefix
          variant="plain"
          iconName="keyboard-backspace"
          shape="square"
          size="small"
          (click)="goBack.emit(); $event.stopImmediatePropagation()"
        />
      }
      {{ 'app.interview.is_candidate_good_fit' | translate }}
    </rt-dropdown-header>
    @if (offers && offers.length > 1) {
      <div class="offer-select" margin-lr margin-bottom>
        <ng-container *ngTemplateOutlet="offerSelect" />
      </div>
    }

    <rt-interview-button-select
      [short]="true"
      [quickEvaluationStyle]="true"
      padding-lr
      formControlName="rating"
    />
    <div class="advanced-button" padding-lr padding-tb-small>
      <rt-button (click)="handleClick()" variant="plain">
        {{ 'app.interview.advanced_options' | translate }}
      </rt-button>
    </div>
  </div>
</ng-template>

<ng-template #offerSelect>
  <rt-offer-select
    [formControl]="$any(quickEvaluationForm.get('offerId'))"
    [offers]="offers"
    [hasSearch]="false"
    [hasInputTrigger]="true"
    [includeEmptyOption]="false"
/></ng-template>
